import { useLocation } from 'react-router-dom'
import { useRouteMetadata } from '../components/inventory/useRouteMetadata'
import { PageHero } from '../components/page-hero/PageHero'
import { contactDirectory } from '../data/contact'
import { useI18n } from '../i18n/I18nProvider'
import './privacy.css'

export function PrivacyPage() {
  const { language, t } = useI18n()
  const { pathname } = useLocation()

  useRouteMetadata({
    title: t('seo.privacyMetadataTitle'),
    description: t('seo.privacyMetadataDescription'),
    pathname,
    language,
  })

  return (
    <div className="privacy-page">
      <PageHero variant="privacy" eyebrow={t('privacy.eyebrow')} title={t('privacy.title')}>
        <p>{t('privacy.intro')}</p>
      </PageHero>

      <section className="privacy-content" aria-label={t('privacy.contentLabel')}>
        <div className="page-frame privacy-content__inner">
          <section>
            <h2>{t('privacy.controllerTitle')}</h2>
            <p>
              {t('privacy.controllerBody')}{' '}
              <a href={`mailto:${contactDirectory.email}`}>{contactDirectory.email}</a>.
            </p>
          </section>

          <section>
            <h2>{t('privacy.dataTitle')}</h2>
            <p>{t('privacy.dataBody')}</p>
          </section>

          <section>
            <h2>{t('privacy.purposeTitle')}</h2>
            <p>{t('privacy.purposeBody')}</p>
          </section>

          <section>
            <h2>{t('privacy.retentionTitle')}</h2>
            <p>{t('privacy.retentionBody')}</p>
          </section>

          <section>
            <h2>{t('privacy.rightsTitle')}</h2>
            <p>
              {t('privacy.rightsBody')}{' '}
              <a href={`mailto:${contactDirectory.email}`}>{contactDirectory.email}</a>.
            </p>
          </section>
        </div>
      </section>
    </div>
  )
}
